<div class="ml-2 mt-1">
  <h1 class="chart-head" *ngIf="!roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.ADVANCED_OUTLET)">Geography Performance</h1>
  <h1 class="chart-head" *ngIf="roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.GEOGRAPHY_CHART_DEALER)">Dealer Performance</h1>
  <h1 class="chart-head" *ngIf="roleService.hasRole(role_id,ROLE_GROUP_CONSTANTS.GEOGRAPHY_CHART_OUTLET)">Outlet Performance</h1>
</div>
<div #chartCarousel id="chartCarousel" class="carousel slide" data-ride="carousel">
  <div class="carousel-inner">
      <!-- ✅ Skeleton loader while charts load -->
  <ng-container *ngIf="loading; else chartContent">
    <div class="row justify-content-center">
      <div class="col-6 chart-body" *ngFor="let i of [1]">
        <div class="donut-skeleton"></div>
        <div class="mt-3">
          <ngx-skeleton-loader 
            [theme]="{ 'width': '240px', 'height': '16px', 'border-radius': '4px', 'margin': '4px 0' }">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #chartContent>

    <ng-container *ngFor="let chart of chartsData; let i = index">
      <ng-container *ngIf="i % 2 === 0">
        <div class="carousel-item" [class.active]="i === 0 && i % 2 === 0">
          <div class="row" *ngIf="i % 2 === 0">
            <div class="col-6 chart-body" *ngIf="chartsData[i + 1]; else singleChart;">
              <p-chart style="width: 240px !important;height: 270px !important;" width="240" height="240"
                type="doughnut" class="pie-chart" [data]="chart.data" [options]="chart.options"></p-chart>
              <div *ngIf="chart.options.title" class="chart-label mt-2">{{ chart.options.title }}
                <div class="chart-sub-label" *ngIf="chart.options.subText1">
                  {{ chart.options.subText1 }}
                </div>
              </div>
            </div>


            <div class="col-6 chart-body" *ngIf="chartsData[i + 1]">
              <p-chart style="width: 240px !important;height: 240px !important;" width="240" height="240"
                type="doughnut" class="pie-chart" [data]="chartsData[i + 1].data"
                [options]="chartsData[i + 1].options"></p-chart>
              <div *ngIf="chartsData[i + 1].options.title" class="chart-label mt-2">
                {{ chartsData[i + 1].options.title }}
                <div class="chart-sub-label" *ngIf="chartsData[i + 1].options.subText1">
                  {{ chartsData[i + 1].options.subText1 }}
                </div>
              </div>
            </div>
            <ng-template #singleChart>
              <div class="col-12 chart-body">
                <p-chart style="width: 240px !important; height: 240px !important;" width="240" height="240"
                  type="doughnut" class="pie-chart" [data]="chart.data" [options]="chart.options"></p-chart>
                <div class="chart-label mt-1" *ngIf="chart.options.title">{{ chart.options.title }}
                  <div class="chart-sub-label" *ngIf="chart.options.subText1">
                    {{ chart.options.subText1 }}
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="chartsData.length == 0">
      <div class="no-data-available">
        <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
      </div>
    </ng-container>
      </ng-template>
  </div>
  <ng-container *ngIf="chartsData.length > 2">
    <button class="carousel-control-prev" style="margin-left: -25px !important;" (click)="prevSlide()" (keydown)="prevSlide()" [disabled]="currentIndex === 0">
      <img src="/assets/images/prev-btn.png" alt="">
    </button>
    <button class="carousel-control-next" style="margin-right: -25px !important;" (click)="nextSlide()" (keydown)="nextSlide()" [disabled]="currentIndex === totalSlides - 1">
      <img src="/assets/images/next-btn.png" alt="">
    </button>
  </ng-container>
</div>
